import { Organization } from './../../common-components/organizations/model/organization.model';
export class EmailDomains {
    ID?: number;
    EMAIL_DOMAIN?: string;
    ORGANIZATION?: Organization;
    ORGANIZATIONS_ID?: number;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}
